import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { statLabel } from "@/lib/stationery";

// Online betalen (kaart, Bancontact, iDEAL, Apple/Google Pay) via een korte link + QR.
export default function PayOnline({ invoiceId, lang = "nl", size = 92 }) {
  if (!invoiceId) return null;
  const url = `${window.location.origin}/api/pay/${invoiceId}`;
  return (
    <div className="flex items-center gap-3 break-inside-avoid" data-testid="pay-online">
      <QRCodeSVG value={url} size={size} level="M" />
      <div className="text-[9px] leading-snug text-slate-600">
        <p className="font-semibold text-slate-800">{statLabel(lang, "pay_online")}</p>
        <p className="text-slate-500">Visa · Mastercard · Bancontact · iDEAL · Apple Pay</p>
        <p className="break-all">{url}</p>
      </div>
    </div>
  );
}
